/**
 * Long-form rows -> one object per bucket, one key per series member, for a given metric.
 *
 * The dashboard endpoints all return long form — one row per (bucket, member) — because that
 * is what GROUP BY produces and it stays correct as members come and go. The charts want wide
 * form. This is the only place that conversion happens, so the digital and offline tabs
 * cannot pivot the same shape two different ways.
 *
 * Capped at eight series: a stacked bar stops being readable past that, and the ninth member
 * is always a sliver.
 */
export function pivot(rows, bucketKey, seriesKey, metric, labelFor = (v) => v) {
  if (!rows?.length) return { keys: [], rows: [] };
  const buckets = [...new Set(rows.map(r => r[bucketKey]))];
  const keys = [...new Set(rows.map(r => r[seriesKey]))].slice(0, 8);
  return {
    keys,
    rows: buckets.map(b => {
      const out = { bucket: labelFor(b) };
      for (const k of keys) {
        out[k] = rows
          .filter(r => r[bucketKey] === b && r[seriesKey] === k)
          .reduce((n, r) => n + Number(r[metric] || 0), 0);
      }
      return out;
    }),
  };
}
